"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteController = void 0;
const analytics_1 = require("@streem/analytics");
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
const utils_1 = require("../wall/utils");
const last_created_at_1 = require("../../util/rx/last_created_at");
class NoteController {
    constructor(config) {
        this.config = config;
        this.notes = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('note'), (0, utils_1.accumulateAndMapWallEvents)('note'));
        this.roomNote = this.notes.pipe((0, utils_1.filterByProperty)('scope', streem_sdk_protobuf_1.streem.api.Note.Scope.SCOPE_ROOM), (0, last_created_at_1.lastCreatedAt)(), (0, operators_1.shareReplay)(1));
    }
    getStreemshotNote(id) {
        return this.notes.pipe((0, utils_1.filterByProperty)('scope', streem_sdk_protobuf_1.streem.api.Note.Scope.SCOPE_STREEMSHOT), (0, utils_1.filterByProperty)('scopeSid', id.toString()), (0, last_created_at_1.lastCreatedAt)());
    }
    /**
     * Saves a streemshot note during an inflight streem.
     * The roomId used is the room the customer is in currently.
     * @param text The streemshot note
     * @param streemshotId The streemshotId
     */
    saveStreemshotNote(streemshotId, text) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when saving Streemshot note');
            try {
                const data = yield api_1.StreemAPI.rooms.updateStreemshotNote(this.config.context.roomId.toString(), streemshotId.toString(), {
                    text,
                    authorSid: this.config.context.localUserId.toString(),
                });
                logger_1.logger.info(`Streemshot note saved for ${streemshotId}`);
                (0, analytics_1.recordNoteSaved)(text.length, streemshotId.toString());
                return data;
            }
            catch (error) {
                logger_1.logger.error(`Failed to save Streemshot note for ${streemshotId}`, error.message);
                throw error;
            }
        });
    }
    /**
     * Save a room note during an inflight streem.
     * The roomId used is the room the customer is in currently.
     * @param text The note being saved to the current room
     */
    saveRoomNote(text) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when saving Streemshot note');
            try {
                yield api_1.StreemAPI.rooms.updateRoomNote(this.config.context.roomId.toString(), {
                    text,
                    authorSid: this.config.context.localUserId.toString(),
                });
                logger_1.logger.info(`Room note updated by ${this.config.context.localUserId}`);
            }
            catch (error) {
                logger_1.logger.error(`Failed to save Room note`, error.message);
                throw error;
            }
        });
    }
    finalizeRoomNote(text) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when sending note');
            try {
                yield api_1.StreemAPI.rooms.finalizeRoomNote(this.config.context.roomId.toString(), {
                    text,
                });
                logger_1.logger.info(`Room note sent by ${this.config.context.localUserId}`);
            }
            catch (error) {
                logger_1.logger.error(`Failed to send note`, error.message);
                throw error;
            }
        });
    }
}
exports.NoteController = NoteController;
//# sourceMappingURL=notes_controller.js.map